import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bcac-modal-description-list',
  templateUrl: './modal-description-list.component.html',
  styleUrls: ['./modal-description-list.component.scss']
})
export class ModalDescriptionListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input()
  bcacColumn: number;
  
  @Input()
  bcacWidth: string = "40rem";

  @Output()
  bcacVisibleEmit: EventEmitter<boolean> = new EventEmitter();

  @Input()
  bcacVisible: boolean = false;

  @Input()
  bcacTitle: string = "";

  @Input()
  bcacData: any = {};

  @Input()
  bcacFields: any[] = [
    {
      value: "mn",
      label: "站点编号"
    },
    {
      value: "mnName",
      label: "站点名称"
    },
    {
      value: "addr",
      label: "地址"
    }
  ];

  modalClose() {
    this.bcacVisible = false;
    this.bcacVisibleEmit.emit(false);
  }
}
